import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomTable,
    RaikoGridOneColumn, RaikoTableTitleContainer, showErrorMessage,
    convertUniversalDateToPersianDate, RaikoDefaultDialogPage, RaikoGridFourColumn, RaikoGridTwoColumn,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneGridTypeItems,
    RaikoCardInfoTypeOneItemGenerator, RaikoCardInfoTypeOneStatusTypes
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {useNavigate} from "react-router-dom";
import {MawakibService} from "../../serverService/mawakibService/MawakibService";



export default function MawakibManagerList() {

    let page = 0
    const size = 15

    const navigate = useNavigate()

    const service = new MawakibService()

    useEffect(() => {
        if (service) {
            getDataFromServer()
        }
    }, [])

    const [mawakibList, setMawakibList] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoadingState, setTableLoadingState] = useState(false);
    const [totalItems, setTotalItems] = useState(0);

    function getDataFromServer() {
        setTableLoadingState(true)

        service.getMawakibList(page, size)
            .then(response => {

                setPageCount(response.totalPage)
                setTotalItems(response.numberOfItems)

                setMawakibList([])

                response.data.map((item, index) => {
                    setMawakibList(prevState => [
                        ...prevState,
                        createMawakibTableRow(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.createdAt,
                            item.createdBy,
                            item.startDate,
                            item.endDate,
                            item.enabled
                        )
                    ])
                })

                setTableLoadingState(false)
            }).catch(reason => {
            showErrorMessage(reason)
            setTableLoadingState(false)
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function handleShowResidenceDetail(itemId) {
        let _title = ""
        mawakibList.map((item) => {
            if (item.id === itemId)
                _title = item.name
        })
        navigate(RouteHelper.MawakibDetails.globalUrl.replace(":id", itemId),
            {state: {title: _title}, replace: false}
        )
    }

    // const [openAddNewResidenceDialogState, setOpenAddNewResidenceDialogState] = useState(false);
    //
    // function handleOpenAddNewResidenceDialog() {
    //     setOpenAddNewResidenceDialogState(true)
    // }
    //
    // function handleCloseAddNewResidenceDialog() {
    //     setOpenAddNewResidenceDialogState(false)
    //     page = 0
    //     getDataFromServer()
    // }

    const [selectDisplayType, setSelectDisplayType] = useState(false)


    return (
        <>
            <Helmet>
                <title>{RouteHelper.MawakibManagerList.name}</title>
            </Helmet>
            {/*<RaikoDefaultDialogPage*/}
            {/*    onClose={handleCloseAddNewResidenceDialog}*/}
            {/*    open={openAddNewResidenceDialogState}>*/}

            {/*</RaikoDefaultDialogPage>*/}
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                "مواکب",
                                RouteHelper.MawakibManagerList.url
                            ),
                            raikoBreadCrumbItemGenerator(
                                "دوره های ثبت نام",
                                ""
                            ),
                        ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={RouteHelper.MawakibManagerList.name}
                                // hasCreateNewItem
                                // handleCreateNewItem={handleOpenAddNewResidenceDialog}
                                amount={totalItems}
                                hasSelectDisplayType
                                selectDisplayType={selectDisplayType}
                                setSelectDisplayType={setSelectDisplayType}
                            />
                            <RaikoCustomTable
                                data={mawakibList}
                                header={mawakibTableHeader}
                                isLoading={tableLoadingState}
                                pageCount={pageCount}
                                handlePaginationChange={handleChangePagination}
                                rowClicked={handleShowResidenceDetail}
                                selectDisplayType={selectDisplayType}
                            >
                                <RaikoGridTwoColumn className={css`padding: 3px;`}>
                                    {
                                        mawakibList.map((item, index) => {
                                            return <RaikoCardInfoTypeOne
                                                key={index}
                                                iconClass={"ic-ambulance"}
                                                title={item.name}
                                                status
                                                statusType={item.enabled ?  RaikoCardInfoTypeOneStatusTypes.SUCCESS :RaikoCardInfoTypeOneStatusTypes.ERROR }
                                                statusText={item.enabled ? "فعال" :"غیر فعال"}
                                                items={[
                                                    RaikoCardInfoTypeOneItemGenerator("تاریخ شروع", item.startDate),
                                                    RaikoCardInfoTypeOneItemGenerator("تاریخ پایان", item.endDate),
                                                    RaikoCardInfoTypeOneItemGenerator("تاریخ ساخت", item.createdAt ? item.createdAt : "-"),
                                                    RaikoCardInfoTypeOneItemGenerator("سازنده", item.createdBy ? item.createdBy : "-"),
                                                ]}
                                                gridTypeItems={RaikoCardInfoTypeOneGridTypeItems.TWO_COLUMN}
                                                onClick={() => {
                                                    handleShowResidenceDetail(item.id)
                                                }}
                                            />
                                        })
                                    }
                                </RaikoGridTwoColumn>
                            </RaikoCustomTable>
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

function createMawakibTableRow(
    id,
    number,
    name,
    createdAt,
    createdBy,
    startDate,
    endDate,
    enabled
) {
    return {
        id,
        number,
        name,
        createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
        createdBy,
        startDate: convertUniversalDateToPersianDate(startDate),
        endDate: convertUniversalDateToPersianDate(endDate),
        enabled,
    }
}


const mawakibTableHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "name",
        label: "نام",
    },
    {
        id: "startDate",
        label: "تاریخ شروع",
    },
    {
        id: "endDate",
        label: "تاریخ پایان",
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت",
    },
    {
        id: "createdBy",
        label: "سازنده",
    },

]
